import { defineTokens } from '@chakra-ui/react/styled-system';

const radii = defineTokens.radii({
  '2': {
    value: '0.125rem',
  },
  '4': {
    value: '0.25rem',
  },
  '6': {
    value: '0.375rem',
  },
  '8': {
    value: '0.5rem',
  },
  '10': {
    value: '0.625rem',
  },
  '12': {
    value: '0.75rem',
  },
  '16': {
    value: '1rem',
  },
  '24': {
    value: '1.5rem',
  },
  full: {
    value: '100%',
  },
});

export default radii;
